
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.07 12.14v5.25a1.875 1.875 0 01-1.874 1.875h-15A1.875 1.875 0 01.32 17.39v-5.25a1.125 1.125 0 112.25 0v4.875h14.25V12.14a1.125 1.125 0 112.25 0zm-10.17.796a1.125 1.125 0 001.594 0l3.75-3.75a1.127 1.127 0 10-1.594-1.594L10.82 9.42V1.64a1.125 1.125 0 10-2.25 0v7.78L6.743 7.595a1.127 1.127 0 00-1.594 1.593L8.9 12.936z","fill":"#27AE60"}})])
          )
        }
      }
    